<ion-icon name="pin" [class.rotated]="isUnpinned"></ion-icon>
